import Globalize from "globalize";
import enMessages from 'devextreme/localization/messages/en.json';
import ptMessages from 'devextreme/localization/messages/pt.json';
import esMessages from 'devextreme/localization/messages/es.json';
import itMessages from 'devextreme/localization/messages/it.json';
import deMessages from 'devextreme/localization/messages/de.json';
import frMessages from 'devextreme/localization/messages/fr.json';
import zhChsMessages from 'devextreme/localization/messages/zh.json';
import supplemental from "devextreme-cldr-data/supplemental.json";
import enCldrData from "devextreme-cldr-data/en.json";
import ptCldrData from "devextreme-cldr-data/pt.json";
import esCldrData from "devextreme-cldr-data/es.json";
import itCldrData from "devextreme-cldr-data/it.json";
import deCldrData from "devextreme-cldr-data/de.json";
import frCldrData from "devextreme-cldr-data/fr.json";
import zhChsCldrData from "devextreme-cldr-data/zh.json";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class GlobalizeService {

  constructor() { }

  initialize() {
    Globalize.load(
      supplemental, 
      enCldrData,
      ptCldrData, 
      esCldrData, 
      itCldrData, 
      deCldrData,
      frCldrData, 
      zhChsCldrData
    );

    Globalize.loadMessages(enMessages);
    Globalize.loadMessages(ptMessages);
    Globalize.loadMessages(esMessages);
    Globalize.loadMessages(itMessages);
    Globalize.loadMessages(deMessages);
    Globalize.loadMessages(frMessages);
    Globalize.loadMessages(zhChsMessages);
    Globalize.locale(navigator.language);
  }

  getGlobalizeInstance() {
    return Globalize;
  }
}
